import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Checkbox} from "@khanacademy/wonder-blocks-form";

interface Props {
    id: string;
    label: string;
    isChecked: boolean;
    onChange: (isChecked: boolean) => void;
    disabled: boolean;
    description?: string;
}

const StudentSettingsCheckbox = (props: Props): React.ReactElement => (
    <View style={styles.container}>
        <Checkbox
            checked={props.isChecked}
            id={props.id}
            onChange={props.onChange}
            disabled={props.disabled}
            description={props.description}
            label={props.label}
        />
    </View>
);

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        justifyContent: "space-between",
    },
});

export default StudentSettingsCheckbox;
